import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock, Tag, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';
import { articles } from '../../data/mock';
import { Badge } from '../ui/badge';

const ArticlesPage = () => {
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('fr-FR', options);
  };

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-24 bg-[#242726]">
        <div className="container-custom">
          <div className="max-w-3xl">
            <span className="caption text-[#c4291c] mb-4 block">Ressources</span>
            <h1 className="heading-1 text-white mb-6">
              Articles & Comprendre le béton précontraint
            </h1>
            <p className="body-large text-white/70">
              Explorez nos articles pour approfondir vos connaissances sur le béton précontraint, ses avantages et ses applications.
            </p>
          </div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="section-padding bg-[#1a1c1b]">
        <div className="container-custom">
          <div className="grid md:grid-cols-2 gap-8">
            {articles.map((article, index) => (
              <article
                key={article.id}
                className="group bg-[#2a2d2c] rounded-2xl overflow-hidden border border-white/10 card-hover"
              >
                <div className="p-8">
                  <div className="flex items-center gap-4 mb-6">
                    <Badge variant="outline" className="border-[#c4291c]/30 text-[#c4291c]">
                      {article.category}
                    </Badge>
                    <div className="flex items-center gap-2 text-white/40 text-sm">
                      <Clock className="w-4 h-4" />
                      <span>{article.readTime} de lecture</span>
                    </div>
                  </div>

                  <h2 className="heading-3 text-white mb-4 group-hover:text-[#c4291c] transition-colors">
                    {article.title}
                  </h2>

                  <p className="text-white/60 body-medium mb-6">
                    {article.excerpt}
                  </p>

                  <div className="flex items-center justify-between">
                    <span className="text-white/40 text-sm">
                      {formatDate(article.date)}
                    </span>
                    <div className="flex items-center gap-2 text-[#c4291c] font-medium group-hover:gap-3 transition-all">
                      <span>Lire l'article</span>
                      <ChevronRight className="w-4 h-4" />
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter CTA */}
      <section className="section-padding bg-[#242726]">
        <div className="container-custom">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="heading-2 text-white mb-6">
              Restez informé
            </h2>
            <p className="text-white/60 body-large mb-8">
              Découvrez nos derniers articles et actualités sur le béton précontraint et la construction en Mauritanie.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/prestressed-concrete">
                <Button className="btn-secondary">
                  En savoir plus sur le béton précontraint
                </Button>
              </Link>
              <a href="https://wa.me/22243111616?text=" target="_blank" rel="noopener noreferrer">
                <Button className="btn-primary">
                  Demander un devis
                  <ArrowRight className="w-4 h-4" />
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ArticlesPage;
